import { FC, useState } from 'react'
import { Button, TextArea } from '@pepper/ui'
import { useHistory } from 'react-router-dom'
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'

import { trimCommaSeparatedList } from '../../../utils'

import s from './Keywords.module.css'

type Props = {
  onChange: () => void
}

export const Keywords: FC<Props> = ({ onChange }) => {
  const [keywords, setKeywords] = useState('')
  const history = useHistory()

  const [queryParams, setQueryParams] = useQueryParams({
    keyword: withDefault(StringParam, undefined),
    sug_keyword: withDefault(StringParam, undefined),
    page: withDefault(NumberParam, 1),
    content_ideas: withDefault(BooleanParam, false),
  })

  const isSuggestionsFilter =
    history.location.pathname === '/content-ideas' || queryParams.content_ideas

  const handleSubmit = () => {
    const keywordsContainList = trimCommaSeparatedList(keywords)
    if (isSuggestionsFilter) {
      setQueryParams({ sug_keyword: keywordsContainList, page: 1 })
    } else {
      setQueryParams({ keyword: keywordsContainList, page: 1 })
    }
    onChange()
  }

  return (
    <div className={s.menu}>
      <div className={s.title}>Enter keywords separated by commas</div>
      <TextArea
        name="keywords-containing"
        className={s.textField}
        placeholder="Example: automation, artificial intelligence, "
        rows={4}
        onChange={event => setKeywords(event.target.value)}
      />
      <div className={s.submit}>
        <Button
          size="large"
          block={false}
          type="primary"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  )
}
